import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    title: "Login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "register",
    title: "Register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(
      () => import("views/auth-views/authentication/register"),
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboards.default",
    path: `${APP_PREFIX_PATH}/default`,
    component: React.lazy(() => import("views/app-views/default")),
  },
  {
    key: "topics-list",
    main: "2",
    path: `${APP_PREFIX_PATH}/topics-list`,
    component: React.lazy(() => import("views/app-views/topics/topics-list")),
  },
  {
    key: "add-topic",
    main: "2",
    path: `${APP_PREFIX_PATH}/add-topic`,
    component: React.lazy(() => import("views/app-views/topics/add-topic")),
  },
  {
    key: "edit-topic",
    title: "Edit Topic",
    main: "2",
    path: `${APP_PREFIX_PATH}/edit-topic`,
    component: React.lazy(() => import("views/app-views/topics/edit-topic")),
  },
  {
    key: "subtopics-list",
    main: "3",
    path: `${APP_PREFIX_PATH}/subtopics-list`,
    component: React.lazy(
      () => import("views/app-views/subtopics/subtopics-list"),
    ),
  },
  {
    key: "add-subtopic",
    main: "3",
    path: `${APP_PREFIX_PATH}/add-subtopic`,
    component: React.lazy(
      () => import("views/app-views/subtopics/add-subtopic"),
    ),
  },
  {
    key: "edit-subtopic",
    main: "3",
    path: `${APP_PREFIX_PATH}/edit-subtopic`,
    component: React.lazy(
      () => import("views/app-views/subtopics/edit-subtopic"),
    ),
  },
  {
    key: "subcategory-list",
    main: "4",
    path: `${APP_PREFIX_PATH}/subcategory-list`,
    component: React.lazy(
      () => import("views/app-views/subcategory/subcategory-list"),
    ),
  },
  {
    key: "add-subcategory",
    main: "4",
    path: `${APP_PREFIX_PATH}/add-subcategory`,
    component: React.lazy(
      () => import("views/app-views/subcategory/add-subcategory"),
    ),
  },
  {
    key: "edit-subcategory",
    main: "4",
    path: `${APP_PREFIX_PATH}/edit-subcategory`,
    component: React.lazy(
      () => import("views/app-views/subcategory/edit-subcategory"),
    ),
  },
  {
    key: "questions-list",
    main: "5",
    path: `${APP_PREFIX_PATH}/questions-list`,
    component: React.lazy(
      () => import("views/app-views/questions/questions-list"),
    ),
  },
  {
    key: "add-question",
    main: "5",
    path: `${APP_PREFIX_PATH}/add-question`,
    component: React.lazy(
      () => import("views/app-views/questions/add-question"),
    ),
  },
  {
    key: "edit-question",
    main: "5",
    path: `${APP_PREFIX_PATH}/edit-question`,
    component: React.lazy(
      () => import("views/app-views/questions/edit-question"),
    ),
  },
  {
    key: "profile",
    path: `${APP_PREFIX_PATH}/profile/*`,
    component: React.lazy(() => import("views/app-views/profile")),
  },
  {
    key: "admin",
    main: "1",
    path: `${APP_PREFIX_PATH}/users`,
    component: React.lazy(() => import("views/app-views/admin")),
  },
  {
    key: "edit-user",
    main: "1",
    path: `${APP_PREFIX_PATH}/edit-user`,
    component: React.lazy(() => import("views/app-views/admin/edit-user")),
  },
  {
    key: "add-user",
    main: "1",
    path: `${APP_PREFIX_PATH}/add-user`,
    component: React.lazy(() => import("views/app-views/admin/add-user")),
  },
  {
    key: "grades",
    main: "5",
    path: `${APP_PREFIX_PATH}/grades`,
    component: React.lazy(() => import("views/app-views/grades")),
  },
  {
    key: "types-list",
    main: "6",
    path: `${APP_PREFIX_PATH}/types-list`,
    component: React.lazy(() => import("views/app-views/types/types-list")),
  },
  {
    key: "add-type",
    main: "6",
    path: `${APP_PREFIX_PATH}/add-type`,
    component: React.lazy(() => import("views/app-views/types/add-type")),
  },
  {
    key: "edit-type",
    main: "6",
    path: `${APP_PREFIX_PATH}/edit-type`,
    component: React.lazy(() => import("views/app-views/types/edit-type")),
  },
];
